import React, { useState, useEffect } from 'react';
import './Header.css';
import logoWhite from '../../assets/images/logo-plus-ojet-edited-white-size-new.png';
import logoBlue from '../../assets/images/logo-plus-ojet-edited-new-size.png';
import { FaPhoneAlt, FaEnvelope, FaBars, FaTimes } from 'react-icons/fa';
import { Link, NavLink } from 'react-router-dom';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [mainWebsiteHover, setMainWebsiteHover] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.classList.toggle('menu-open', menuOpen);
    return () => document.body.classList.remove('menu-open');
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <header className={`header-wrapper ${scrolled ? 'scrolled' : ''}`}>
      {/* Top Header */}
      <div className="top-header">
        <div className="contact-info">
          <span>
            <a href="tel:+919619065205" className="contact-link">
              <FaPhoneAlt style={{ marginRight: '8px' }} />
              +91 9619065205
            </a>
          </span>
          <span>
            <a href="mailto:sales@sabiote.in" className="contact-link">
              <FaEnvelope style={{ marginRight: '8px' }} />
              sales@sabiote.in
            </a>
          </span>
        </div>
      </div>

      {/* Main Header */}
      <div className="main-header-whole-box">
        <div className="main-header">
          <div className="logo">
            <Link to="/">
              <img src={scrolled ? logoBlue : logoWhite} alt="Sabiote Logo" />
            </Link>
          </div>

          <div className="mobile-menu-toggle" onClick={() => setMenuOpen(true)}>
            <FaBars />
          </div>

          {/* Mobile Fullscreen Nav */}
          <nav className={`nav-menu ${menuOpen ? 'open' : ''}`}>
            <button className="menu-close-btn" onClick={closeMenu}>
              <FaTimes />
            </button>
            <NavLink
              to="/"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? 'active' : '')}
              end
            >
              Home
            </NavLink>
            <NavLink
              to="/innovation"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              Our Innovation Story
            </NavLink>
            <NavLink
              to="/resources"
              onClick={closeMenu}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              Resources & Downloads
            </NavLink>

            <a
              href="https://sabiote.in/"
              target="_blank"
              rel="noopener noreferrer"
              onClick={closeMenu}
              className="main-website-link pulse-effect"
              onMouseEnter={() => setMainWebsiteHover(true)}
              onMouseLeave={() => setMainWebsiteHover(false)}
              style={{
                display: 'inline-block',
                width: '130px',
                textAlign: 'center',
                whiteSpace: 'nowrap',
              }}
            >
              {mainWebsiteHover ? '👋 Click Me' : '🌐 Main Website'}
            </a>

          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
